import React from 'react';
import { OpTable, IOpTableProps } from 'components/customAntd/DLS/OpTable/OpTable';
import { OpTableRawColumnType } from 'components/customAntd/DLS/OpTableCore/OpTableCore';
import { Location } from 'types/locationTypes';
import { TABLE_HEIGHT } from 'constants/ui';
import { useTranslation } from 'react-i18next';

interface AvigilonReadersTableProps {
    acus: any[];
    setAcus: (setAcus: any[]) => void;
    handleEditClick: (acu: any) => void;
    loading: boolean;
}

const AvigilonReadersTable: React.FC<AvigilonReadersTableProps> = ({ acus, setAcus, handleEditClick, loading }) => {
    const { t } = useTranslation();
    const columns: OpTableRawColumnType[] = [
        {
            dataIndex: 'name',
            label: t('avigilonReader.table.name'),
            filter: {
                type: 'input',
            },
            sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
        },
        {
            dataIndex: 'notes',
            label: t('avigilonReader.table.description'),
            filter: {
                type: 'input',
            },
            sorter: (a, b) => (a.notes || '').localeCompare(b.notes || ''),
        },
        {
            dataIndex: 'statusMessage',
            label: t('avigilonReader.table.status'),
            filter: {
                type: 'input',
            },
            sorter: (a, b) => (a.statusMessage || '').localeCompare(b.statusMessage || ''),
        },
    ];

    const opTableProps: IOpTableProps = {
        dataSource: acus,
        columns: columns,
        rowActions: {
            onEditClick: (location: Location) => handleEditClick(location),
        },
        height: TABLE_HEIGHT,
        allowGlobalSearch: true,
        loading: loading,
        allowExport: true,
        allowShowHideColumns: true,
    };

    return <>
        <OpTable {...opTableProps} />
    </>;
};

export default AvigilonReadersTable;
